// Turns positions into heatmap tiles.
//
// Shared so the master portfolio and the index colour identically. Size is
// market value in base currency; colour is unrealised P/L as a percentage of
// what was paid, not of current value — a position up 100% has doubled, and
// dividing by the current value would report that as +50%.

/**
 * Unrealised P/L as a percentage of cost, or null when it cannot be said.
 *
 * Prefers the broker's own cost basis; falls back to deriving it, so a source
 * that reports P/L but not cost still gets a figure.
 */
export function unrealizedPct(p) {
    const value = Number(p.marketValueBase ?? 0);
    const pnl = p.unrealizedPnlBase === null || p.unrealizedPnlBase === undefined
        ? null
        : Number(p.unrealizedPnlBase);
    const cost = p.costBasis !== null && p.costBasis !== undefined && Number(p.costBasis) !== 0
        ? Number(p.costBasis)
        : pnl !== null
          ? value - pnl
          : null;
    const pct = pnl === null || cost === null || cost <= 0 ? null : (pnl / cost) * 100;
    return Number.isFinite(pct) ? pct : null;
}

export function positionTiles(positions) {
    return positions
        .map((p) => ({
            key: `${p.source}-${p.accountLabel}-${p.symbol}`,
            label: p.symbol,
            name: p.name,
            logoSymbol: p.symbol,
            value: Number(p.marketValueBase ?? 0),
            changePct: unrealizedPct(p),
        }))
        .filter((t) => t.value > 0);
}

/** Tiles for index rows, which carry `value` rather than `marketValueBase`. */
export function indexRowTiles(rows) {
    return rows
        .map((r) => ({
            key: `${r.sleeve}-${r.symbol}`,
            label: r.symbol,
            name: r.name,
            logoSymbol: r.symbol,
            value: Number(r.value ?? 0),
            // Coloured by drift against target, not by P/L: on this page the
            // question is "is this position the right size", and the band is
            // what answers it.
            changePct: r.relativeDriftPct ?? null,
        }))
        .filter((t) => t.value > 0);
}
